import { IconButton } from '@components/iconButton';
import * as SVG from '@assets/svgs';
import { Tooltip } from '@components/tooltip';

export const TooltipDownload = () => (
  <Tooltip placement='top' title='Download'>
    <IconButton variant='rounded' size='small'>
      <SVG.CloudDownload width='15px' height='15px' />
    </IconButton>
  </Tooltip>
);
